import { ServerContext } from './context'

export const ServerContextProvider = ServerContext.Provider
